import React from 'react';
import { OutlinedDropdown } from 'library';
import { styled } from '@mui/material';
import type { SelectChangeEvent } from '@mui/material/Select';
import { useHistory } from 'react-router';

import type { PagingResult, IBusinessLocation } from 'models';

export function LocationsDropDown({
    data,
    small,
    location,
}: {
    data?: PagingResult<IBusinessLocation>;
    small: boolean;
    location?: string;
}) {
    const history = useHistory();
    const paramLocation = new URLSearchParams(window.location.search).get('location');
    function handleLocationChange(e: SelectChangeEvent<string | number | null>) {
        const params = new URLSearchParams(window.location.search);
        params.set('location', e.target.value as string);
        const url = `timesheets?${params.toString()}`;
        history.push(url);
    }

    return (
        <Container small={small.toString()}>
            <OutlinedDropdown
                textLabel="Location"
                value={paramLocation || location || ''}
                fields={
                    data?.results.map((b) => {
                        return { key: b.id.toString(), value: b.name };
                    }) || []
                }
                onChange={(e) => handleLocationChange(e)}
            />
        </Container>
    );
}

const Container = styled('div')(({ small }: { small: string }) => ({
    width: small === 'true' ? '100%' : '30%',
    marginBottom: 10,
}));
